module.exports = __webpack_public_path__ + "img/logo-getprofirt-white.f666db25.svg";